import React from 'react';
import { Bar } from 'react-chartjs-2';
import 'chart.js/auto';

interface MonthData {
  month_short: string;
  total_budget: number;
  total_actual_sales: number;
  cumplimiento_pct: number;
  proyeccion_pesos: number;
}

interface BudgetsMonthlyChartProps {
  monthly: MonthData[];
}

export default function BudgetsMonthlyChart({ monthly = [] }: BudgetsMonthlyChartProps) {

  const barData = {
    labels: monthly.map(m => m.month_short),
    datasets: [
      {
        label: 'Presupuesto ($)',
        data: monthly.map(m => m.total_budget),
        backgroundColor: 'rgba(54, 162, 235, 0.6)',
        borderColor: 'rgba(54, 162, 235, 1)',
        borderWidth: 1,
        barPercentage: 0.8,
        categoryPercentage: 0.6,
        yAxisID: 'y',
      },
      {
        label: 'Ventas Reales ($)',
        data: monthly.map(m => m.total_actual_sales),
        backgroundColor: 'rgba(46, 125, 50, 0.6)',
        borderColor: 'rgba(46, 125, 50, 1)',
        borderWidth: 1,
        barPercentage: 0.8,
        categoryPercentage: 0.6,
        yAxisID: 'y',
      },
      {
        label: 'Proyección ($)',
        data: monthly.map(m => m.proyeccion_pesos),
        backgroundColor: 'rgba(255, 159, 64, 0.6)',
        borderColor: 'rgba(255, 159, 64, 1)',
        borderWidth: 1,
        barPercentage: 0.8,
        categoryPercentage: 0.6,
        yAxisID: 'y',
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: 'top' as const,
      },
      tooltip: {
        callbacks: {
          label: (context: any) => {
            const value = context.raw;
            return `${context.dataset.label}: $${Number(value).toLocaleString()}`;
          },
        },
      },
    },
    scales: {
      y: {
        type: 'linear' as const,
        display: true,
        position: 'left' as const,
        title: {
          display: true,
          text: 'Monto ($)',
        },
        ticks: {
          callback: (value: any) => '$' + Number(value).toLocaleString(),
        },
      },
    },
  };

  return (
    <div className="bar-chart">
      <Bar data={barData} options={options} />
    </div>
  );
}
